module.exports = __webpack_public_path__ + "static/OR0s-e977732417b5e3513ac77be3d4be52ed.jpg";